"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Casestudyshowcase() {
  const containerRef = useRef<HTMLDivElement>(null);
  const caseStudies = [{
    number: "01",
    category: "ENGENHARIA",
    title: "Produção de Vidro",
    description: "Lave, seque e revista vidro e garrafas de forma eficaz, eficiente e sem danificar o produto.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.35.png?v=8h8yvn6rr55",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.35.png?v=lv3ui4sozs-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.35.png?v=tooq15ol3m-wvc-sizes",
    alt: "Sistemas de pulverização e engenharia de refrigeração industrial"
  }, {
    number: "02",
    category: "EXPERIÊNCIA",
    title: "Produtos Têxteis e Não Tecidos",
    description: "Garanta a aplicação precisa e eficiente de revestimentos, corantes, adesivos, retardantes de fogo, agentes de desmoldagem e muito mais.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.59.png?v=b5bkij3pw3d",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.59.png?v=jjfdj77jx5p-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.19.59.png?v=othryn6h5pl-wvc-sizes",
    alt: "Consultoria técnica e sistemas de limpeza de tanques"
  }, {
    number: "03",
    category: "COBERTURA",
    title: "OEM e Empresas de Engenharia",
    description: "Trabalhe com os nossos especialistas em engenharia para desenvolver uma solução de tecnologia de pulverização personalizada.",
    image: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.20.30.png?v=wx440l17yde",
    srcset: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.20.30.png?v=a9xpe0tmu3-wvc-srcset",
    sizes: "https://simple-elk.10web.cloud/wp-content/uploads/2026/08/Captura-de-ecra-2026-08-11-as-16.20.30.png?v=4cj294v2vpm-wvc-sizes",
    alt: "Sistemas de pulverização e suporte técnico industrial"
  }];
  useGSAP(() => {
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReducedMotion) return;
    gsap.from(".study-card", {
      opacity: 0,
      y: 36,
      stagger: 0.15,
      duration: 0.75,
      ease: "power3.out",
      scrollTrigger: {
        trigger: containerRef.current,
        start: "top 80%"
      }
    });
  }, {
    scope: containerRef
  });
  return <section data-section-id="31348" id="casestudyshowcase" ref={containerRef} className="relative overflow-hidden bg-background text-foreground py-24 md:py-32">
      <div className="relative mx-auto max-w-[1360px] px-5 sm:px-8 lg:px-14">
        {}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 md:mb-20">
          

          <div className="shrink-0">
            <Button asChild variant="outline" className="h-auto rounded-lg border border-border bg-card px-5 py-3 text-foreground transition-colors hover:bg-accent hover:text-accent-foreground">
              <Link to="/ContactsPage" className="inline-flex items-center gap-2">
                <span className="font-default text-sm font-medium">Fale com um especialista</span>
                <ArrowUpRight className="size-4" />
              </Link>
            </Button>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {caseStudies.map((cs, i) => <article key={i} data-index={i} className="study-card group flex flex-col overflow-hidden rounded-3xl border border-border/80 bg-card p-6 sm:p-7 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md">
              {}
              <div className="relative w-full aspect-[3/2] overflow-hidden rounded-xl bg-muted mb-6">
                <img src={cs.image} data-wvc-srcset={cs.srcset} data-wvc-sizes={cs.sizes} alt={cs.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105" />
              </div>

              {}
              <span className="font-default text-xs font-medium uppercase tracking-widest text-muted-foreground mb-2 block">
                {cs.number} — {cs.category}
              </span>

              {}
              <h3 className="font-default text-xl sm:text-2xl font-bold text-foreground mb-3 leading-snug">
                {cs.title}
              </h3>

              {}
              <p className="font-default text-sm sm:text-base text-muted-foreground leading-relaxed">
                {cs.description}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}